// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"style_inputWrapper__3UKAG","input":"style_input__QAXl9","remainingTime":"style_remainingTime__psXFR","resend":"style_resend__3f6vO","actions":"style_actions__21-3u"};